import { init_coverage } from './coverage_plugin';

$(document).ready(function() {
    let $sectionObj = $('.check-coverage');
    init_coverage($sectionObj);
});
    
